import { AxiosError } from "axios";
import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { IImportExcelTemplateRequest } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateCompanyAction } from "./useGetCompanyActionHistory";
import { useInvalidateCompanyEmployeeViews } from "./useGetCompanyEmployeeViews";
import { useInvalidateNeedsAttentionData } from "./useGetNeedsAttentionData";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;

  payload: IImportExcelTemplateRequest;
};

const updateClient = async ({
  countryCode,
  clientInternalNumberGOS,
  payload,
}: Params): Promise<string> => {
  const response = await api.post(
    `/company/template/${countryCode}/${clientInternalNumberGOS}`,

    {
      ...payload,
    }
  );

  return response.data;
};

export function useImportEmployeesFromExcel() {
  const invalidateCompanyEmployees = useInvalidateCompanyEmployeeViews();
  const invalidateCompanyActions = useInvalidateCompanyAction();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateNeedsAttentionData = useInvalidateNeedsAttentionData();

  return useMutation(updateClient, {
    mutationKey: MUTATION_KEYS.importEmployeesFromExcel,
    onSuccess: () => {
      invalidateNeedsAttentionData();
      invalidateCompanyEmployees();
      // queryClient.refetchQueries({ queryKey: QUERY_KEYS.benefitCategories });
      invalidateCompanyActions();
    },
    onError: (error: AxiosError) => {
      handleAddAxiosErrorNotification(error);
    },
  });
}
